var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"intio-word"},[_c('div',{staticClass:"positioning"},[_c('sticker',{attrs:{"alt":"INTIO","img":"intio"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }